import { render, staticRenderFns } from "./sub-head-secondary.vue?vue&type=template&id=71ac6ad6&scoped=true"
import script from "./sub-head-secondary.vue?vue&type=script&lang=js"
export * from "./sub-head-secondary.vue?vue&type=script&lang=js"
import style0 from "./sub-head-secondary.vue?vue&type=style&index=0&id=71ac6ad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ac6ad6",
  null
  
)

export default component.exports